<template>
  <div class="room-item">
    <router-link :to="$store.getters['main/getSingleUrl'](blog)" class="img">
      <picture>
        <source
          class="img-absolute"
          media="(max-width: 767px)"
          :srcset="_.get(blog, `images[0].devices.mobile`)"
        />
        <source
          class="img-absolute"
          media="(max-width: 1023px)"
          :srcset="_.get(blog, `images[0].devices.tablet`)"
        />
        <img
          loading="lazy"
          :src="_.get(blog, `images[0].devices.desktop`)"
          class="img-absolute"
          alt
        />
      </picture>
    </router-link>
    <div class="data-cont">
      <p class="date font-16 tbc-medium">{{ formatDate(blog.date) }}</p>
      <router-link
        class="txt font-18"
        :to="$store.getters['main/getSingleUrl'](blog)"
      >
        {{ blog.title }}
      </router-link>
    </div>
  </div>
</template>

<script>
import moment from "moment";

export default {
  props: ["blog"],
  data() {
    return {};
  },
  methods: {
    formatDate(date) {
      return moment(date).format("D MMM, YYYY");
    }
  }
};
</script>

<style scoped>
.room-item {
  width: 100%;
  height: 100%;
  margin-right: 30px;
  margin-bottom: 30px;
  border-radius: 4px;
  border: 1px solid #364756;
  overflow: hidden;
}
.room-item:nth-child(2n) {
  margin-right: 0px;
}
.room-item .img {
  position: relative;
  padding-bottom: 51.4%;
  overflow: hidden;
  cursor: pointer;
  display: block;
}
.room-item .img img {
  transition: 0.6s;
}
.room-item .data-cont {
  margin-top: 35px;
  padding-left: 30px;
  padding-right: 30px;
  padding-bottom: 45px;
}
.room-item .date {
  color: #00a3e0;
}
.room-item .txt {
  line-height: 27px;
  margin-top: 14px;
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
}

@media (min-width: 1024px) {
  .room-item .img:hover img {
    transform: scale(1.1);
  }
}
/* @media (max-width: 1023px) {

} */
@media (max-width: 767px) {
  .room-item {
    width: 100%;
    margin-right: 0px;
  }
  .room-item .data-cont {
    padding: 20px;
    margin-top: 20px;
  }
}
</style>
